<nz-badge [nzCount]="trip?.active_incident_count" [nzOverflowCount]="100" class="w-full"
    [nzOffset]="[trip.alarm_count > 10 ? -2 : -8, 15]">
    <nz-card [routerLink]="['/trips/',trip?.trip_id]" role="group"
        [ngClass]="{'text-danger': trip?.active_incident_count > 0}"
        class="glass-card my-2 h-auto cursor-pointer">
        <div class="space-y-3">
            <div class="flex items-center justify-between gap-1 text-xs text-gray-500 mb-2">
                <div class="flex items-center gap-x-1">
                    <span class="font-medium text-gray-700">Trip ID:</span>
                    <span>{{ trip?.trip_id || 'N/A' }}</span>
                </div>
                <app-battery-and-signal [batteryPercentage]="trip?.sensor?.last_readings?.battery"
                    [view]="['battery']"></app-battery-and-signal>
            </div>
            <app-trip-route [locationData]="[{ location: trip?.sender_location?.display_name, type: 'leg' },
                                    { location: trip?.legs[trip?.legs?.length - 1]?.location?.display_name, type: 'last-leg'}]"
                [legCount]="trip?.legs?.length - 1" [isIncident]="trip?.active_incident_count > 0" />
            <div class="bg-gray-200 rounded-full relative overflow-hidden">
                <div class="h-2 rounded-full bg-gradient-to-r from-blue-500 to-purple-400"
                    [style.width.%]="getProgress(trip)" [style.animation-delay]="'0.1s'">
                </div>
            </div>
            <div
                class="flex gap-4 items-center overflow-x-auto no-scrollbar divide-x-2 divide-gray-200 divide-solid my-1"
                [ngClass]="{'text-success': trip?.active_incident_count == 0, 'text-danger': trip?.active_incident_count > 0}">
                <ng-container *ngFor="let capability of trip?.capabilities; index as i; trackBy: feUtil.trackByFn">
                    <div class="min-w-[100px] flex items-center gap-x-2" [ngClass]="{'pl-4': i > 0}">
                        <i nz-icon [nzType]="'hezky:' + capability"
                            nzTheme="outline" class="text-2xl -mr-1.5 -ml-1 mt-0.5"></i>
                        <span class="text-3xl font-normal">
                            {{ feUtil.getFormattedTemp(trip?.sensor?.last_readings?.[capability],capability) }}
                        </span>
                    </div>
                </ng-container>
            </div>
            <div class="flex flex-wrap items-center justify-between gap-2">
                <div class="flex items-center gap-1 text-xs text-gray-500">
                    <i nz-icon nzType="calendar" nzTheme="outline" class="text-blue-400"></i>
                    <span class="font-medium text-gray-700">Start Date:</span>
                    <span>{{ trip?.start_date | gDate }}</span>
                </div>
                <div class="flex items-center gap-1 text-xs text-gray-500">
                    <i nz-icon nzType="clock-circle" nzTheme="outline" class="text-purple-400"></i>
                    <span class="font-medium text-gray-700">Last Reading:</span>
                    <span>
                        {{ trip?.sensor?.last_readings?.timestamp ? (trip?.sensor?.last_readings?.timestamp | relativeTime:'card-relative') : 'N/A' }}
                    </span>
                </div>
            </div>
        </div>
    </nz-card>
</nz-badge>